import { styled } from '@cp/ds/src/theme';
import { CatalogList } from './catalogList';

const name = 'CatalogFlexList';
export const CatalogFlexList = styled(CatalogList, { name })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));
